<template>
    <form @submit.prevent>
        <div>
            <template v-if="page.status == 'en_revision' && canUnpublish">
                <table class="table" width="100%">                    
                    <template v-if="agendado">
                        <tr>
                            <td>
                                Actualmente la publicación está agendada para el <label>{{formatDate(oldDatetime)}}.</label>
                                <br />
                                Si lo desea puede modificar la fecha más abajo.                             
                                <br />
                                <br />
                                <label>¿Desea agendar una fecha de publicación?</label>
                                <el-switch v-model="rel_flag"  on-text="SI" off-text="NO"></el-switch>
                            </td>
                        </tr>
                    </template>   
                    <template v-else>                 
                        <tr>
                            <td>
                                <label>¿Desea agendar una fecha de publicación?</label>
                                <el-switch v-model="rel_flag"  on-text="SI" off-text="NO"></el-switch>
                            </td>
                        </tr>
                    </template>
                    <tr>  
                        <td>                                      
                            <template v-if="rel_flag == true">
                                <div class="block">
                                    <span class="demonstration">Seleccione Fecha y Hora </span>
                                    <el-date-picker
                                        v-model="rel_datetime"
                                        :clearable="false"
                                        type="datetime"
                                        format="yyyy-MM-dd HH:mm"
                                        placeholder="Seleccionar">
                                    </el-date-picker>
                                </div>
                            </template>            
                        </td>
                    </tr>
                </table>
            </template>
        </div>
        <br />
        <div class="text-center">
            <template v-if="page.status == 'en_revision'">
                <button class="btn btn-success" @click.prevent='data.action = "publish"; submit();'>{{buttonText}}</button>
                <button class="btn btn-primary" @click.prevent='data.action = "reject"; dialogVisible = true;'>Rechazar con observaciones</button>
            </template>
            <template v-else>
                <button class="btn btn-success" @click.prevent='data.action = "revise"; submit();'>Enviar a Revisión</button>
            </template>
            <button v-if="page.published && canUnpublish" class="btn btn-danger" @click.prevent='data.action = "unpublish"; dialogVisible = true;'>Despublicar</button>
            <!--
            <button v-if="page.status == ''  || page.status == 'rechazado'" class="btn btn-primary" @click.prevent="submit('en_revision')">Enviar a Revisión</button>
            <template v-else>
                <button class="btn btn-success" @click.prevent='submit()'>Aprobar y Publicar</button>
                <button class="btn btn-primary" @click.prevent='dialogVisible = true'>Rechazar con observaciones</button>
                <button class="btn btn-danger">Despublicar</button>
            </template>
            -->           
        </div>
        <el-dialog title="Observaciones" :visible.sync="dialogVisible" size="tiny">
            <div class="form-group">
                <label>Justificación</label>
                <textarea v-model="data.status_comment" class="form-control" rows="5" placeholder="Escriba la justificación del rechazo."></textarea>
            </div>
            <span slot="footer" class="dialog-footer">
                <button @click.prevent="dialogVisible = false" class="btn">Cancelar</button>
                <button class="btn btn-primary" @click.prevent="submit()">Enviar</button>
            </span>
        </el-dialog>
    </form>
</template>
<script>
    
    import ElDialog from 'element-ui/lib/dialog';
    import { Message } from "element-ui";
    
    export default {
        data: function(){
            return{
                moment:moment,
                dialogVisible: false,
                buttonText: 'test',
                rel_datetime: moment(this.page.release_date == '0000-00-00 00:00:00' ? moment().format('YYYY-MM-DD HH:mm') : this.page.release_date).format('YYYY-MM-DD HH:mm'),
                rel_flag: this.page.release_flag === 1  ? true : this.page.release_flag === 0 ? false : '',
                data: {
                    action: null,
                    status_comment: '',
                    schedulePublication: '',
                    pickedDatetime: '',
                },
                
                agendado: false,
                oldDatetime: '',
                errors: {}
            }
        },
        mounted:function(){
            if (this.rel_flag === false)
            {
                this.agendado = false;
                this.buttonText = 'Aprobar y Publicar';
                this.data.schedulePublication = false;
                this.data.pickedDatetime = moment().format('YYYY-MM-DD HH:mm');
            }
            if (this.rel_flag === true)
            {                
                this.agendado = true;
                this.buttonText = 'Aprobar y Agendar';
                this.data.schedulePublication = true;
                this.data.pickedDatetime = this.rel_datetime;
                this.oldDatetime = this.rel_datetime;
            }
        },
        watch:{
            rel_flag:function(flag){
                if(flag == false)
                {
                    this.data.pickedDatetime = moment().format('YYYY-MM-DD HH:mm');
                    this.rel_datetime = moment().format('YYYY-MM-DD HH:mm');
                    this.data.schedulePublication = false;
                    this.buttonText = 'Aprobar y Publicar';
                } else {
                    this.data.schedulePublication = true;
                    this.buttonText = 'Aprobar y Agendar';
                }
            },
            rel_datetime:function(p_date){
                this.data.pickedDatetime = moment(p_date).format('YYYY-MM-DD HH:mm');
                this.rel_datetime = moment(p_date).format('YYYY-MM-DD HH:mm');

            }
        },
        props: ['page','canUnpublish'],
        components:{
            ElDialog
        },
        methods:{
            submit: function(){
                var self = this;

                if (this.data.action == "publish" && this.data.schedulePublication == true)
                {
                    if (self.data.pickedDatetime < moment().format('YYYY-MM-DD HH:mm'))
                    {
                        self.$message.error("La fecha y hora seleccionada no puede ser menor a la actual.");
                        return false;   
                    } else {
                        axios({
                            url: 'backend/fichas/'+self.page.id+'/status',
                            method: 'PUT',
                            data: {
                                action: self.data.action,
                                status_comment: self.data.status_comment,
                                schedulePublication: self.data.schedulePublication,
                                pickedDatetime: self.data.pickedDatetime
                            },
                        }).then(function(response){
                            window.location.replace(response.data.redirect);
                        }).catch(function(error){
                            self.errors = error.response.data.errors;
                        });
                    }                    
                } else {
                    axios({
                        url: 'backend/fichas/'+self.page.id+'/status',
                        method: 'PUT',
                        data: {
                            action: self.data.action,
                            status_comment: self.data.status_comment,
                            schedulePublication: self.data.schedulePublication,
                            pickedDatetime: self.data.pickedDatetime
                        },
                    }).then(function(response){
                        window.location.replace(response.data.redirect);
                    }).catch(function(error){
                        self.errors = error.response.data.errors;
                    });
                }
            },
            formatDate:function(date){
                var fecha = moment(date, 'YYYY/MM/DD HH:mm');                
                return fecha.format("D") + ' de ' + fecha.format("MMMM") +' de ' + fecha.format("YYYY") +' a las '+fecha.format("HH:mm")+' hrs' ;
            }
        }
    }
</script>